
/* ===== inline script block ===== */

(function(){
  var btn=document.getElementById('seeMore');
  var grid=document.querySelector('.st-cards');
  if(btn&&grid){btn.addEventListener('click',function(){
    grid.classList.add('expanded');
    grid.querySelectorAll('.st-card--more').forEach(function(c){c.classList.add('in');});
    var wrap=btn.closest('.st-more'); if(wrap) wrap.style.display='none';
  });}
})();


/* ===== inline script block ===== */

/* ---------- Year ---------- */
document.getElementById('yr').textContent = new Date().getFullYear();

/* ---------- Header: yellow over hero, white after scroll ---------- */
(function(){
  const header=document.querySelector('.header');
  const hero=document.querySelector('.hero');
  if(!header) return;
  function onScroll(){
    const threshold=hero ? Math.max(hero.offsetHeight-header.offsetHeight,60) : 60;
    header.classList.toggle('is-scrolled', window.scrollY > threshold);
  }
  onScroll();
  window.addEventListener('scroll', onScroll, {passive:true});
  window.addEventListener('resize', onScroll);
})();


/* ---------- Hero mobile slider (auto-rotate) ---------- */
const heroTrack=document.getElementById('heroTrack');
if(heroTrack){
  const heroDots=document.querySelectorAll('#heroDots span');
  let heroI=0;
  setInterval(()=>{heroI=(heroI+1)%heroDots.length;heroTrack.scrollTo({left:heroTrack.clientWidth*heroI,behavior:'smooth'})},4000);
  heroTrack.addEventListener('scroll',()=>{
    const i=Math.round(heroTrack.scrollLeft/heroTrack.clientWidth);
    heroI=i;heroDots.forEach((d,idx)=>d.classList.toggle('is-active',idx===i));
  });
}

/* ---------- Mobile nav drawer (slides from left) ---------- */
const menuToggle=document.getElementById('menuToggle'),mobileNav=document.getElementById('mobileNav');
const navOverlay=document.getElementById('navOverlay'),navClose=document.getElementById('navClose');
function openNav(){mobileNav.classList.add('open');navOverlay.classList.add('open');menuToggle.setAttribute('aria-expanded',true)}
function closeNav(){mobileNav.classList.remove('open');navOverlay.classList.remove('open');menuToggle.setAttribute('aria-expanded',false)}
menuToggle.addEventListener('click',openNav);
navClose.addEventListener('click',closeNav);
navOverlay.addEventListener('click',closeNav);
mobileNav.querySelectorAll('a').forEach(a=>a.addEventListener('click',closeNav));
document.addEventListener('keydown',e=>{if(e.key==='Escape')closeNav()});

/* ---------- Mobile search toggle ---------- */
const searchToggle=document.querySelector('.search-toggle'),searchBox=document.querySelector('.search');
const searchBack=document.querySelector('.search__back');
function closeSearch(){searchBox.classList.remove('search--open')}
searchToggle.addEventListener('click',()=>{const o=searchBox.classList.toggle('search--open');if(o)searchBox.querySelector('input').focus()});
if(searchBack)searchBack.addEventListener('click',closeSearch);
document.addEventListener('keydown',e=>{if(e.key==='Escape')closeSearch()});

/* ---------- Product data (placeholders) ---------- */
const bestSellers=[
  {name:'Veg Khavsa',cat:'Street Food',title:'Veg. Khavsa',now:179,was:299,desc:'Coconut-curry noodle bowl, ready in 10 min',badge:'NEW LAUNCH',flag:true,rating:'4.8',rc:'272',img:'MOCKUP/MOCKUP/VEG%20KHAVSA%20-%20F.jpg'},
  {name:'Cheese Angoori',cat:'Main Course',title:'Cheese Angoori',now:219,was:289,desc:'Soft cheese angoori in creamy gravy',badge:'BESTSELLER',flag:true,rating:'4.9',rc:'71',img:'MOCKUP/MOCKUP/CHEESE%20ANGOORI%20-%20F.jpg'},
  {name:'Cheese Gotalo',cat:'Main Course',title:'Cheese Gotalo',now:209,was:279,desc:'Cheesy paneer gotalo, rich & indulgent',badge:'HOT DROP',rating:'4.8',rc:'95',img:'MOCKUP/MOCKUP/CHEESE%20PANEER%20GOTALO%20-%20F.jpg'},
  {name:'Gajar Halwo',cat:'Sweets',title:'Gajar Halwo',now:199,was:299,desc:'Slow-cooked carrot halwa with ghee & nuts',badge:'GHAR JAISA',rating:'4.8',rc:'53',img:'MOCKUP/MOCKUP/GAJAR%20HALWA%20-%20F.jpg'},
  {name:'Rasawala Khaman',cat:'Street Food',title:'Rasawala Khaman',now:149,was:199,desc:'Soft khaman soaked in spiced curry',badge:'STREET CLASSIC',rating:'4.8',rc:'96',img:'MOCKUP/MOCKUP/RASAWALA%20KHAMAN%20-%20F.jpg'},
  {name:'Surti Locho',cat:'Street Food',title:'Surti Locho',now:149,was:199,desc:'Steamed, layered locho with butter & sev',flag:true,rating:'4.9',rc:'188',img:'MOCKUP/MOCKUP/CHEECE%20LOCHO%20-%20F.jpg'},
  {name:'Surti Undhiyu',cat:'Main Course',title:'Surti Undhiyu',now:199,was:299,desc:'Rich winter mixed-veg with muthiya',badge:'BESTSELLER',benefit:'Ghee-Rich',rating:'4.8',rc:'143',img:'MOCKUP/MOCKUP/SURTI%20UNDHIYU%20-%20F.jpg'},
  {name:'Sev Khamani',cat:'Street Food',title:'Sev Khamani',now:139,was:189,desc:'Crumbled dhokla with sev & pomegranate',badge:'MOST RE-ORDERED',benefit:'Street-Style',rating:'4.7',rc:'210',img:'MOCKUP/MOCKUP/SEV%20KHAMANI%20-%20F.jpg'},
  {name:'Rasawala Khaman',cat:'Street Food',title:'Rasawala Khaman',now:149,was:199,desc:'Soft khaman soaked in spiced curry',badge:'HOT DROP',benefit:'Soft & Juicy',rating:'4.8',rc:'96',img:'MOCKUP/MOCKUP/RASAWALA%20KHAMAN%20-%20F.jpg'},
  {name:'Paneer Butter Masala',cat:'Main Course',title:'Paneer Butter Masala',now:199,was:269,desc:'Creamy tomato gravy with soft paneer',badge:'TOP RATED',benefit:'Rich & Creamy',rating:'4.8',rc:'175',img:'MOCKUP/MOCKUP/PANEER%20BUTTER%20MASALA%20-%20F.jpg'},
  {name:'Surti Chat',cat:'Street Food',title:'Surti Chat',now:139,was:189,desc:'Tangy street-style Surti chaat',badge:'BESTSELLER',benefit:'Tangy',rating:'4.7',rc:'120',img:'MOCKUP/MOCKUP/SURTI%20CHAT%20-%20F.jpg'}
];
const combos=[
  {name:'Sev Khamani Combo',cat:'Street Food',title:'Sev Khamani — Pack of 5',now:649,was:945,desc:'Five packs of crumbled dhokla with sev',badge:'VALUE PACK',benefit:'Pack of 5',rating:'4.8',rc:'88',img:'product%20image/combo.jpeg'},
  {name:'Sev Usal Combo',cat:'Street Food',title:'Sev Usal — Pack of 10',now:1199,was:1890,desc:'Ten packs of spicy Surti sev usal',badge:'FAMILY PACK',benefit:'Pack of 10',rating:'4.8',rc:'64',img:'product%20image/combo%20(1).jpeg'},
  {name:'Surti Locho Combo',cat:'Street Food',title:'Surti Locho — Pack of 5',now:695,was:995,desc:'Five packs of soft steamed locho',badge:'BESTSELLER',benefit:'Pack of 5',rating:'4.9',rc:'77',img:'product%20image/combo%20(2).jpg'},
  {name:'Gajar Halwa Combo',cat:'Sweets',title:'Gajar Halwa — Pack of 5',now:845,was:1245,desc:'Five packs of rich carrot halwa',badge:'FESTIVE',benefit:'Pack of 5',rating:'4.8',rc:'53',img:'product%20image/combo.jpeg'},
  {name:'Sev Khamani Combo',cat:'Street Food',title:'Sev Khamani — Pack of 10',now:1199,was:1890,desc:'Ten packs of crumbled dhokla with sev',badge:'PARTY PACK',benefit:'Pack of 10',rating:'4.8',rc:'42',img:'product%20image/combo%20(1).jpeg'},
  {name:'Surti Locho Combo',cat:'Street Food',title:'Surti Locho — Pack of 10',now:1299,was:1990,desc:'Ten packs of soft steamed locho',badge:'PARTY PACK',benefit:'Pack of 10',rating:'4.9',rc:'39',img:'product%20image/combo%20(2).jpg'},
  {name:'Gajar Halwa Combo',cat:'Sweets',title:'Gajar Halwa — Pack of 10',now:1599,was:2490,desc:'Ten packs of rich carrot halwa',badge:'GIFT PACK',benefit:'Pack of 10',rating:'4.8',rc:'31',img:'product%20image/combo.jpeg'},
  {name:'Sev Usal Combo',cat:'Street Food',title:'Sev Usal — Pack of 5',now:649,was:945,desc:'Five packs of spicy Surti sev usal',badge:'VALUE PACK',benefit:'Pack of 5',rating:'4.7',rc:'47',img:'product%20image/combo%20(1).jpeg'}
];

function stars(){return '<span class="stars" aria-hidden="true">★★★★★</span>'}
function card(p){
  return `<article class="card reveal">
    <div class="card__media">
      <span class="card__tag chip">${p.tag}</span>
      <span class="card__avail">In stock</span>
      <div class="ph"><span>${p.shot}</span></div>
    </div>
    <div class="card__body">
      <div>
        <div class="card__name">${p.name}</div>
        <div class="card__guj">${p.guj}</div>
      </div>
      <div class="card__rating">${stars()} <span>[4.8] · [${(Math.floor(Math.random()*300)+80)}]</span></div>
      <div class="card__price"><span class="now">[₹${p.now}]</span><span class="was">[₹${p.was}]</span></div>
      <button class="btn btn--primary btn--block" data-add="${p.name}" data-price="${p.now}">Quick add +</button>
    </div>
  </article>`;
}
/* Product card */
const flagColors=[
  {bg:'#FCE500',fg:'#000'},   /* Bright Lemon */
  {bg:'#1eb473',fg:'#fff'},   /* Medium Jungle green */
  {bg:'#FCE500',fg:'#000'},   /* Bright Lemon */
  {bg:'#000000',fg:'#FCE500'},/* Black + yellow */
  {bg:'#1eb473',fg:'#fff'},   /* Medium Jungle green */
  {bg:'#000000',fg:'#FCE500'} /* Black + yellow */
];
function bsCard(p,i){
  const c=flagColors[i%flagColors.length];
  const disc=Math.round((p.was-p.now)/p.was*100);
  return `<article class="bs-card">
    <div class="bs-card__media">
      ${p.flag?`<span class="bs-card__tag" style="background:${c.bg};color:${c.fg}"><span>${p.badge||'TOP RATED'}</span></span>`:''}
      ${p.img?`<img src="${p.img}" alt="${p.name}" loading="lazy">`:`<div class="ph"><span>${p.shot||p.name}</span></div>`}
      ${p.hover?`<img class="bs-card__hover" src="${p.hover}" alt="" aria-hidden="true" loading="lazy">`:''}
    </div>
    <div class="bs-card__body">
      <div class="bs-card__rating"><span class="rstars">★★★★★</span><span>(${p.rc||'120'})</span></div>
      <div class="bs-card__name">${p.title||p.name}</div>
      <p class="bs-card__meta"><span class="bs-card__meta-i">Net Wt. ${p.grams||'400g'}</span></p>
      <div class="bs-card__pack">
        <span>Pack:</span>
        <div class="pack-opts">
          <button type="button" class="pack-opt is-active">1</button>
          <button type="button" class="pack-opt">2</button>
          <button type="button" class="pack-opt">3</button>
          <button type="button" class="pack-opt">4</button>
        </div>
      </div>
      <div class="bs-card__foot">
        <div class="bs-card__pricewrap">
          <div class="bs-card__price"><span class="now">₹${p.now}</span><span class="was">₹${p.was}</span><span class="bs-card__save">Save ${disc}%</span></div>
          
        </div>
        <button class="bs-card__add" data-add="${p.name}" data-price="${p.now}"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>ADD</button>
      </div>
    </div>
  </article>`;
}
const bsTrack=document.getElementById('bsTrack');
if(bsTrack){
  bsTrack.innerHTML=bestSellers.slice(0,6).map(bsCard).join('');
  const bsStep=()=>bsTrack.clientWidth*0.85;
  const _bp=document.getElementById('bsPrev'),_bn=document.getElementById('bsNext');
  if(_bp)_bp.addEventListener('click',()=>bsTrack.scrollBy({left:-bsStep(),behavior:'smooth'}));
  if(_bn)_bn.addEventListener('click',()=>bsTrack.scrollBy({left:bsStep(),behavior:'smooth'}));
}
const comboTrack=document.getElementById('comboTrack');
if(comboTrack){
  comboTrack.innerHTML=combos.slice(0,3).map(bsCard).join('');
  const cbStep=()=>comboTrack.clientWidth*0.85;
  const _cp=document.getElementById('cbPrev'),_cn=document.getElementById('cbNext');
  if(_cp)_cp.addEventListener('click',()=>comboTrack.scrollBy({left:-cbStep(),behavior:'smooth'}));
  if(_cn)_cn.addEventListener('click',()=>comboTrack.scrollBy({left:cbStep(),behavior:'smooth'}));
}


const showTrack=document.getElementById('showTrack');
/* duplicate reels once for a seamless auto-scroll loop */
if(showTrack&&!showTrack.dataset.looped){showTrack.dataset.looped='1';showTrack.innerHTML+=showTrack.innerHTML;}
const pressTrack=document.getElementById('pressTrack');
if(pressTrack&&!pressTrack.dataset.looped){pressTrack.dataset.looped='1';pressTrack.innerHTML+=pressTrack.innerHTML;}

/* Hill's-style reviews carousel */
const hprReviews=[
  {title:"Tastes just like home!",quote:"Made the Khavsa and in 10 minutes it tasted just like home! Living in London, it felt like a little bit of Surat arrived.",name:"Krupa P.",loc:"London, UK",img:"videos/WhatsApp%20Image%202026-06-16%20at%204.52.03%20PM.jpeg"},
  {title:"Just like mum's",quote:"The Undhiyu tastes just like my mum's. Five minutes and a proper dinner is done after a long shift.",name:"Megha S.",loc:"Dubai, UAE",img:"videos/WhatsApp%20Image%202026-06-16%20at%204.52.09%20PM.jpeg"},
  {title:"Surprisingly fresh",quote:"Genuinely surprised how fresh it tastes. No preservatives and still bursting with real Surti flavour.",name:"Priya N.",loc:"New Jersey, US",img:"videos/WhatsApp%20Image%202026-06-16%20at%204.52.06%20PM.jpeg"},
  {title:"Hostel life sorted",quote:"I've put the instant noodles aside — now it's Surti Locho whenever I miss home. Tastes exactly like Surat.",name:"Rohan M.",loc:"Student · Toronto",img:"videos/WhatsApp%20Image%202026-06-16%20at%204.52.05%20PM.jpeg"},
  {title:"Best decision ever",quote:"Carried a few packs to my hostel. Best decision — warm Surti food whenever I'm homesick, no cooking needed.",name:"Karan T.",loc:"London, UK",img:"videos/WhatsApp%20Image%202026-06-16%20at%204.52.04%20PM.jpeg"},
  {title:"Perfect to gift",quote:"Ordered the combo for my parents abroad. Zero preservatives and full of flavour. Perfect to give as a gift.",name:"Anjali D.",loc:"Sydney, AU",img:"videos/WhatsApp%20Image%202026-06-16%20at%204.52.07%20PM.jpeg"}
];
const hprStar='<svg viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" stroke-linecap="round"><path d="M12 3.2l2.55 5.17 5.7.83-4.13 4.02.97 5.68L12 16.2l-5.09 2.68.97-5.68L3.75 9.22l5.7-.83z"/></svg>';
function hprCardHTML(r){
  return `<article class="hpr-card">
    <div class="hpr-card__media"><img src="${r.img}" alt="" loading="lazy"></div>
    <div class="hpr-card__text">
      <div class="hpr-card__stars">${hprStar.repeat(5)}</div>
      <h3 class="hpr-card__title">${r.title}</h3>
      <p class="hpr-card__quote">${r.quote}</p>
      <div class="hpr-card__name">${r.name}<small>${r.loc}</small></div>
    </div>
  </article>`;
}
const hprTrack=document.getElementById('hprTrack');
if(hprTrack){
  hprTrack.innerHTML=hprReviews.map(hprCardHTML).join('');
  const hprStep=()=>hprTrack.clientWidth*0.85;
  document.getElementById('hprPrev').addEventListener('click',()=>hprTrack.scrollBy({left:-hprStep(),behavior:'smooth'}));
  document.getElementById('hprNext').addEventListener('click',()=>hprTrack.scrollBy({left:hprStep(),behavior:'smooth'}));
}


/* ---------- Visual cart ---------- */
var cart=(function(){try{return JSON.parse(localStorage.getItem('surtiflavour_cart'))||[]}catch(e){return[]}})();
const drawer=document.getElementById('drawer'),overlay=document.getElementById('overlay');
const cartCount=document.getElementById('cartCount'),cartTotal=document.getElementById('cartTotal');
const drawerItems=document.getElementById('drawerItems'),drawerEmpty=document.getElementById('drawerEmpty');
const toast=document.getElementById('toast');
let toastTimer;

function openCart(){drawer.classList.add('open');overlay.classList.add('open');drawer.setAttribute('aria-hidden','false')}
function closeCart(){drawer.classList.remove('open');overlay.classList.remove('open');drawer.setAttribute('aria-hidden','true')}
document.getElementById('cartOpen').addEventListener('click',openCart);
document.getElementById('cartClose').addEventListener('click',closeCart);
overlay.addEventListener('click',closeCart);
document.addEventListener('keydown',e=>{if(e.key==='Escape')closeCart()});

function showToast(msg){toast.textContent=msg;toast.classList.add('show');clearTimeout(toastTimer);toastTimer=setTimeout(()=>toast.classList.remove('show'),1800)}

function render(){
  try{localStorage.setItem('surtiflavour_cart',JSON.stringify(cart))}catch(e){}
  const count=cart.reduce((n,i)=>n+i.qty,0);
  const total=cart.reduce((s,i)=>s+i.qty*i.price,0);
  cartCount.textContent=count;
  cartTotal.textContent='₹'+total;
  if(!cart.length){drawerItems.innerHTML='';drawerItems.appendChild(drawerEmpty);drawerEmpty.style.display='';return}
  drawerEmpty.style.display='none';
  drawerItems.innerHTML=cart.map((i,idx)=>`
    <div class="ci">
      <div class="ci__thumb">${i.img?`<img src="${i.img}" alt="${i.name}">`:''}</div>
      <div class="ci__info">
        <div class="ci__name">${i.name}</div>
        <div class="ci__meta">${i.meta||'Ready-to-eat'}</div>
        <div class="ci__price">₹${i.price} <span class="each">/ pack · ₹${i.price*i.qty} total</span></div>
        <div class="qty">
          <button aria-label="Decrease" data-dec="${idx}">−</button>
          <span>${i.qty}</span>
          <button aria-label="Increase" data-inc="${idx}">+</button>
        </div>
      </div>
      <button class="ci__rm" aria-label="Remove" data-rm="${idx}">×</button>
    </div>`).join('');
}
function add(name,price,img,meta){
  const ex=cart.find(i=>i.name===name);
  if(ex)ex.qty++;else cart.push({name,price:Number(price),qty:1,img:img||'',meta:meta||''});
  render();showToast(name+' added ✓');
}
render();
document.addEventListener('click',e=>{
  const a=e.target.closest('[data-add]');
  if(a){add(a.dataset.add,a.dataset.price);openCart();return}
  const mt=e.target.closest('.reel__mute');
  if(mt){const v=mt.parentElement.querySelector('video');if(v){v.muted=!v.muted;if(!v.muted)v.play();mt.style.opacity=v.muted?'1':'.55';}return}
  const pk=e.target.closest('.pack-opt');
  if(pk){pk.parentElement.querySelectorAll('.pack-opt').forEach(b=>b.classList.remove('is-active'));pk.classList.add('is-active');return}
  const inc=e.target.closest('[data-inc]');if(inc){cart[inc.dataset.inc].qty++;render();return}
  const dec=e.target.closest('[data-dec]');if(dec){const i=cart[dec.dataset.dec];i.qty--;if(i.qty<=0)cart.splice(dec.dataset.dec,1);render();return}
  const rm=e.target.closest('[data-rm]');if(rm){cart.splice(rm.dataset.rm,1);render();return}
});

/* ---------- Scroll reveal ---------- */
const io=new IntersectionObserver((entries)=>{
  entries.forEach(en=>{if(en.isIntersecting){en.target.classList.add('in');io.unobserve(en.target)}})
},{threshold:.12});
document.querySelectorAll('.reveal').forEach(el=>io.observe(el));

/* ---------- Rounded star icons in review cards ---------- */
(function(){
  const star='<svg viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" stroke-linecap="round"><path d="M12 3.2l2.55 5.17 5.7.83-4.13 4.02.97 5.68L12 16.2l-5.09 2.68.97-5.68L3.75 9.22l5.7-.83z"/></svg>';
  document.querySelectorAll('.rev-card__stars').forEach(s=>s.innerHTML=star.repeat(5));
})();

/* ---------- Count-up stats on scroll ---------- */
function countUp(el){
  const target=parseFloat(el.dataset.count),dec=parseInt(el.dataset.dec||'0'),suffix=el.dataset.suffix||'';
  const dur=1500,start=performance.now();
  (function step(now){
    const p=Math.min((now-start)/dur,1),eased=1-Math.pow(1-p,3),val=target*eased;
    el.textContent=(dec?val.toFixed(dec):Math.round(val))+suffix;
    if(p<1)requestAnimationFrame(step);else {el.textContent=(dec?target.toFixed(dec):target)+suffix;el.classList.add("num-pop");}
  })(start);
}
const statsSec=document.querySelector('.stats');
if(statsSec){
  const sObs=new IntersectionObserver((ents,o)=>{
    ents.forEach(e=>{if(e.isIntersecting){document.querySelectorAll('.stat b[data-count]').forEach(countUp);o.disconnect();}});
  },{threshold:.3});
  sObs.observe(statsSec);
}
const authSec=document.querySelector('.auth');
if(authSec){
  const aObs=new IntersectionObserver((ents,o)=>{
    ents.forEach(e=>{if(e.isIntersecting){authSec.querySelectorAll('.auth__num[data-count]').forEach(countUp);o.disconnect();}});
  },{threshold:.3});
  aObs.observe(authSec);
}

/* ---------- Footer accordions (mobile) ---------- */
document.querySelectorAll('.footer__col-head').forEach(function(btn){
  btn.addEventListener('click',function(){
    if(window.innerWidth>640) return;              // accordion only on phones
    var col=btn.closest('.footer__col');
    var open=col.classList.toggle('open');
    btn.setAttribute('aria-expanded', open);
  });
});


/* ===== inline script block ===== */
(function(){var p=(location.pathname.split("/").pop()||"").toLowerCase();if(!p)return;document.querySelectorAll(".nav a[href]").forEach(function(a){if((a.getAttribute("href")||"").toLowerCase()===p)a.setAttribute("aria-current","page");});})();
